export {InfoMessage} from './InfoMessage'
export type {InfoMessageProps} from './InfoMessage'
